module.exports = __webpack_public_path__ + "img/odonto_cura_nucleo.cba75d6d.jpg";